import React from "react"
import { css, useTheme } from "@emotion/react"
import LoopComponents from "./LoopComponents"

export default function ComponentWrapper({ children }) {
  const theme = useTheme()

  css.wrapper = css`
    width: 100%;

    > * {
      margin-bottom: 80px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    @media (min-width: ${theme.breakpoints.tablet}) {
      > * {
        margin-bottom: 120px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  `

  return (
    <div css={css.wrapper}>
      <LoopComponents components={children} />
    </div>
  )
}
